<template>
  <v-dialog v-model="show" max-width="500" persistent>
    <v-card class="pl-5 pr-5 pt-5">
      <v-card-text class="body-1" v-html="text"></v-card-text>
      <v-card-actions>
        <v-container class="text-right pa-0 ma-0">
          <v-btn text color="error" large @click="ok">ok</v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from "../EventBus";

export default {
  name: "AMessageDialog",
  data() {
    return {
      title: "",
      text: "",
      show: false,
      onOk: undefined,
    };
  },
  mounted() {
    EventBus.$on("MessageDialogOpen", d => {
      this.open(d);
    });
  },
  methods: {
    open(d) {
      this.title = d ? d.title : "";
      this.text = d ? d.text : "";
      this.onOk = d ? d.onOk : undefined;
      this.show = true;
    },
    ok() {
      this.show = false;
      this.$emit("ok");
      if (this.onOk) this.onOk();
    }
  }
};
</script>